import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_FORMAT_CLIENT_PARAMS, DATE_TIME_FORMAT_CLIENT, ROLES } from '../../helpers/constants'
import { useTranslation } from 'react-i18next'
import { Button, Space } from 'antd'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
// @ts-ignore
import ReactExport from 'react-data-export'
import moment from 'moment'
import { useRef, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import { cloneDeep, groupBy, isError, reduce, set } from 'lodash'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const ExportToCSV = observer((props: any) => {
   const { t } = useTranslation()
   const UserStore = useStore('UserStore')

   const [rows, setRows] = useState<any[]>([])

   const exportRef = useRef(null)

   const handleExportData = async () => {
      try {
         const data = await UserStore.getAllEmployees({})
         setRows(data.rows || [])
         if (exportRef.current !== null) {
            // @ts-ignore
            exportRef.current!.click()
         }
      } catch (error) {}
   }

   const exportToCSV = () => {
      return (
         <ExcelFile
            element={
               <Button ref={exportRef}>
                  {t(GLOBAL_CLIENT.exportCSV)}
                  <DownloadOutlined />
               </Button>
            }
            filename={`Danh sách tài khoản ${moment().format('HH:mm:ss DD-MM-YYYY')}`}
         >
            <ExcelSheet com data={rows} name="PurchaseOrderManagement">
               <ExcelColumn label={'ID'} value="id" />
               <ExcelColumn label={'email'} value="email" />
               <ExcelColumn label={'role'} value="role" />
               <ExcelColumn label={'name'} value="name" />
               <ExcelColumn label={'phoneNumber'} value="phoneNumber" />
               <ExcelColumn label={'Ship wallet'} value={(col: any) => col?.wallet?.balance || '0'} />
            </ExcelSheet>
         </ExcelFile>
      )
   }

   return (
      <Space>
         <Button onClick={handleExportData}>
            {t(GLOBAL_CLIENT.exportExcel)}
            <DownloadOutlined />
         </Button>
         <div style={{ display: 'none' }}>{exportToCSV()}</div>
      </Space>
   )
})

export default ExportToCSV
